import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";
import { useEffect, useRef, useState } from "react";
import PageWrapper from "../../../components/PageWrapper";

const HEADER_ROW_HEIGHT = 56;
const SEARCHBAR_HEIGHT = 56.5;
const TABLE_ROW_HEIGHT = 63;
const CARD_PADDING = 32;

const RenderLoading = () => {
  const divRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number>(0);

  const updateHeight = () => {
    if (divRef.current) {
      setHeight(divRef.current.offsetHeight);
    }
  };

  const getCountSkeletons = () => {
    if (height) {
      let possibleCells =
        (height - CARD_PADDING - HEADER_ROW_HEIGHT - SEARCHBAR_HEIGHT) /
        TABLE_ROW_HEIGHT;
      return Math.floor(possibleCells);
    } else {
      return 11;
    }
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <PageWrapper>
      <div className="card h-full" ref={divRef}>
        <div className="flex items-center mb-4 gap-10">
          <Skeleton variant="rectangular" width="15%" height={40} />
          <Skeleton variant="rectangular" width="15%" height={40} />
          <Skeleton variant="rectangular" width="15%" height={40} />
          <Skeleton variant="rectangular" width="15%" height={40} />
          <Skeleton variant="rectangular" width="15%" height={40} />
        </div>

        <div className="mb-4">
          <Skeleton variant="rectangular" width="25%" height={40} />
        </div>

        <TableContainer>
          <Table>
            <TableHead className="bg-gray-200">
              <TableRow>
                <TableCell sx={{ width: "250px" }}>
                  <Skeleton width="90%" variant="rectangular" />
                </TableCell>
                <TableCell sx={{ width: "150px" }}>
                  <Skeleton width="90%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" variant="rectangular" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: getCountSkeletons() }).map((_, index) => (
                <TableRow key={index} className="hover:bg-gray-100">
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton width="90%" variant="rectangular" />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton width="85%" variant="rectangular" />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton width="75%" variant="rectangular" />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton width="70%" variant="rectangular" />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton width="85%" variant="rectangular" />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton width="70%" variant="rectangular" />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton width="85%" variant="rectangular" />
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom:
                        index == getCountSkeletons() - 1 ? "none" : "",
                    }}
                  >
                    <Skeleton variant="rectangular" width="50%" height={30} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </PageWrapper>
  );
};

export default RenderLoading;
